var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTether = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 24.231,
    viewBox: "0 0 89 24.231",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tether",
    transform: "translate(-4.465 -13.693)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 12.116,
    cy: 12.116,
    r: 12.116,
    transform: "translate(4.465 13.693)",
    fill: "#26a17b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73",
    transform: "translate(9.031 19.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_190",
    "data-name": "Trazado 190",
    d: "M36.746,51.558v0c-.084.006-.516.031-1.478.031-.769,0-1.309-.021-1.5-.031v0c-2.959-.131-5.166-.645-5.166-1.262s2.209-1.132,5.166-1.262v2.012c.193.014.748.047,1.513.047.919,0,1.379-.039,1.465-.047v-2.01c2.953.132,5.154.647,5.154,1.262s-2.2,1.13-5.154,1.262m0-2.733v-1.8h4.12V44.283H29.65v2.745h4.12v1.8c-3.348.154-5.865.816-5.865,1.611s2.519,1.457,5.865,1.613v5.77h2.978v-5.77c3.342-.154,5.855-.816,5.855-1.611s-2.513-1.457-5.855-1.611",
    transform: "translate(-27.905 -44.283)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_191",
    "data-name": "Trazado 191",
    d: "M163.317,41.8v2.91h2.828V46.9H163.3v4.427a1.272,1.272,0,0,0,1.33,1.455,2.9,2.9,0,0,0,1.227-.312l.707,2.162a5.69,5.69,0,0,1-2.1.436c-2.224.084-3.679-1.184-3.679-3.742V46.9H158.87V44.714h1.913V42.075Zm48.76,2.774.187,1.184a3.023,3.023,0,0,1,2.891-1.455,3.888,3.888,0,0,1,2.639.976l-1.143,2.2a2.535,2.535,0,0,0-1.829-.666,2.365,2.365,0,0,0-2.558,2.6v5.405h-2.536V44.574Zm-6.216,3.929c-.166-1.33-1.206-2-2.661-2a2.762,2.762,0,0,0-2.869,2Zm-5.571,2.1c.166,1.268,1.268,2.184,3.056,2.184a4.238,4.238,0,0,0,2.745-.956l1.621,1.6A6.3,6.3,0,0,1,203.3,55.1c-3.533,0-5.635-2.184-5.635-5.468a5.13,5.13,0,0,1,5.448-5.364c3.43,0,5.573,2.121,5.177,6.34ZM189.106,40.273v5.7a3.788,3.788,0,0,1,3.2-1.539c2.91,0,4.2,1.975,4.2,4.99v5.405h-2.536V49.441c0-1.872-.978-2.661-2.33-2.661a2.626,2.626,0,0,0-2.536,2.807v5.24H186.57V40.275Zm-6.736,1.414V44.6H185.2v2.184h-2.848v4.427a1.273,1.273,0,0,0,1.33,1.455,2.9,2.9,0,0,0,1.227-.312l.707,2.162a5.689,5.689,0,0,1-2.1.436c-2.224.084-3.679-1.186-3.679-3.742V46.781h-1.913V44.6h1.913V41.958Zm-7.006,6.819c-.166-1.33-1.206-2-2.661-2a2.762,2.762,0,0,0-2.869,2Zm-5.571,2.1c.166,1.268,1.268,2.184,3.056,2.184a4.238,4.238,0,0,0,2.745-.956l1.621,1.6a6.3,6.3,0,0,1-4.408,1.663c-3.535,0-5.635-2.184-5.635-5.468a5.13,5.13,0,0,1,5.446-5.364c3.43,0,5.571,2.121,5.177,6.34Z",
    transform: "translate(-124.329 -21.403)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTether);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tether.4d25a749537f88a7abc5328336689174.svg";